export const flipObject = obj => {
    const result = {};
    Object.keys(obj).forEach(key => {
        result[obj[key]] = key;
    });
    return result;
};
export const filterObject = (obj, predicate) => {
    const result = {};
    Object.keys(obj).forEach(key => {
        if (predicate(obj[key], key)) {
            result[key] = obj[key];
        }
    });
    return result;
};

export const debounce = (fn, delay) => {
    let that;
    let args;
    let ts;
    let timeout;

    const delayed = () => {
        const since = Date.now() - ts;
        if (since < delay) {
            timeout = setTimeout(delayed, delay - since);
        } else {
            timeout = undefined;
            fn.apply(that, args);
        }
    };

    return function wrap(...fnArgs) {
        that = this;
        args = fnArgs;
        ts = Date.now();
        if (timeout === undefined) {
            timeout = setTimeout(delayed, delay);
        }
    };
};

export const isVowel = char => {
    if (typeof char !== 'string') return false;
    return /^[aeiou]$/.test(char.toLowerCase());
};

export const isObjectEmpty = json => (
    Object.keys(json).length === 0 && json.constructor === Object
);


export const toQueryString = object =>
    Object.keys(object).length ? `?${Object.keys(object).map(key =>
        `${encodeURIComponent(key)}=${encodeURIComponent(object[key].toString())}`
    ).join('&')}` : '';